import { motion } from "framer-motion";
import { Phone, MessageCircle, MapPin, ArrowUpRight, Clock } from "lucide-react";
import { SITE } from "../../lib/site";

export const Contact = () => {
  return (
    <section
      id="iletisim"
      data-testid="contact-footer"
      className="bg-zinc-950 text-white"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-24 sm:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-7">
            <div className="text-xs tracking-[0.25em] uppercase font-bold text-zinc-500 mb-6 flex items-center gap-3">
              <span className="w-8 h-px bg-[#00844A]" />
              04 — İletişim
            </div>
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6 }}
              className="font-display font-black text-5xl sm:text-6xl lg:text-7xl xl:text-8xl tracking-tighter leading-[0.92]"
            >
              Projenizi <br />
              <span className="italic font-medium text-zinc-500">konuşalım.</span>
            </motion.h2>
            <p className="mt-8 text-base sm:text-lg text-zinc-400 max-w-xl leading-relaxed">
              Keşif randevusu, fiyatlandırma veya teknik bir soru için
              telefon veya WhatsApp üzerinden bize ulaşın. Aynı gün dönüş
              yapıyoruz.
            </p>
          </div>

          <div className="lg:col-span-5 space-y-4">
            <a
              href={`tel:${SITE.phoneTel}`}
              data-testid="contact-cta-call"
              className="group flex items-center justify-between p-6 border border-white/15 hover:border-[#00844A] hover:bg-[#00844A] hover:text-white transition-all duration-300"
            >
              <div>
                <div className="text-xs tracking-[0.2em] uppercase font-bold text-zinc-500 group-hover:text-white/90 mb-2">
                  Telefon
                </div>
                <div className="font-display font-black text-2xl sm:text-3xl tracking-tight">
                  {SITE.phoneDisplay}
                </div>
              </div>
              <div className="w-12 h-12 border border-white/20 group-hover:border-white flex items-center justify-center">
                <Phone size={18} />
              </div>
            </a>

            <a
              href={SITE.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-cta-whatsapp"
              className="group flex items-center justify-between p-6 border border-white/15 hover:border-[#00844A] hover:bg-[#00844A] hover:text-white transition-all duration-300"
            >
              <div>
                <div className="text-xs tracking-[0.2em] uppercase font-bold text-zinc-500 group-hover:text-white/90 mb-2">
                  WhatsApp
                </div>
                <div className="font-display font-black text-2xl sm:text-3xl tracking-tight">
                  Hızlı Fiyat Sor
                </div>
              </div>
              <div className="w-12 h-12 border border-white/20 group-hover:border-white flex items-center justify-center">
                <MessageCircle size={18} />
              </div>
            </a>

            <a
              href={SITE.mapsQuery}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-cta-address"
              className="group flex items-start justify-between gap-4 p-6 border border-white/15 hover:border-[#00844A] hover:bg-white/5 transition-all duration-300"
            >
              <div className="flex-1">
                <div className="text-xs tracking-[0.2em] uppercase font-bold text-zinc-500 mb-2">
                  Adres
                </div>
                <div className="font-display font-bold text-base sm:text-lg tracking-tight leading-snug">
                  {SITE.address}
                </div>
              </div>
              <div className="w-12 h-12 border border-white/20 flex items-center justify-center shrink-0">
                <MapPin size={18} />
              </div>
            </a>

            <div className="flex items-center gap-3 p-6 border border-white/10 bg-white/5">
              <Clock size={16} className="text-[#00844A]" />
              <div className="text-sm text-zinc-300">
                Pazartesi — Cumartesi · 09:00 — 19:00
              </div>
            </div>
          </div>
        </div>

        {/* Footer line */}
        <div className="mt-24 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img
              src="/assets/artibir-logo.png"
              alt="Artı Bir Yapı"
              className="h-9 w-auto object-contain"
              style={{ filter: "brightness(0) invert(1)" }}
            />
          </div>
          <div className="text-xs text-zinc-500 flex flex-col sm:flex-row gap-4">
            <span>{SITE.domain}</span>
            <span className="hidden sm:inline">·</span>
            <span>© {new Date().getFullYear()} Artı Bir Yapı. Tüm hakları saklıdır.</span>
          </div>
          <a
            href="#"
            className="text-xs tracking-[0.2em] uppercase font-bold text-zinc-400 hover:text-[#00844A] flex items-center gap-2 transition-colors"
            data-testid="footer-back-top"
          >
            Yukarı çık <ArrowUpRight size={14} />
          </a>
        </div>
      </div>
    </section>
  );
};
